"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ButtonsGroup = _interopRequireDefault(require("../ButtonsGroup"));
var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledButton = _ButtonsGroup["default"].StyledButton,
  ButtonsGroupPropTypes = _ButtonsGroup["default"].propTypes,
  ButtonsGroupDefaultProps = _ButtonsGroup["default"].defaultProps;
var ToggleButtonsGroup = /*#__PURE__*/function (_React$PureComponent) {
  function ToggleButtonsGroup(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ToggleButtonsGroup);
    _this = _callSuper(this, ToggleButtonsGroup, [props]);
    _this.state = {
      values: props.values
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleRef = _this.handleRef.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(ToggleButtonsGroup, _React$PureComponent);
  return (0, _createClass2["default"])(ToggleButtonsGroup, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var values = _ref.values;
      var prevValues = this.state.values;
      if (!(0, _isEqual2["default"])(values, prevValues)) {
        this.setState({
          values: values
        });
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var detail = event.detail;
      var nextValue = detail.value;
      var _this$props = this.props,
        isMultiple = _this$props.multiple,
        onChange = _this$props.onChange;
      nextValue = isMultiple ? nextValue : [nextValue.pop()];
      this.setState({
        values: nextValue
      });
      event.detail.value = nextValue;
      this.el.dispatchEvent(event);
      onChange(event);
    }
  }, {
    key: "handleRef",
    value: function handleRef(component) {
      this.el = _reactDom["default"].findDOMNode(component);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      var values = this.state.values;
      var key = values ? values.join('') : '';
      return /*#__PURE__*/_react["default"].createElement(StyledToggleButtonsGroup, (0, _extends2["default"])({}, props, {
        key: key,
        onChange: this.handleChange,
        ref: this.handleRef,
        values: values
      }), children);
    }
  }]);
}(_react["default"].PureComponent);
ToggleButtonsGroup.propTypes = _objectSpread(_objectSpread({}, ButtonsGroupPropTypes), {}, {
  multiple: _propTypes["default"].bool
});
ToggleButtonsGroup.defaultProps = _objectSpread(_objectSpread({}, ButtonsGroupDefaultProps), {}, {
  multiple: false
});
var StyledToggleButtonsGroup = (0, _styledComponents["default"])(_ButtonsGroup["default"]).withConfig({
  displayName: "ToggleButtonsGroup__StyledToggleButtonsGroup",
  componentId: "sc-j3tbwc-0"
})(["height:36px;display:flex;", "{border:none;height:100%;padding:0 8px;border-radius:0;line-height:normal;border-top:solid 1px #007aff;border-bottom:solid 1px #007aff;:focus{z-index:2;}&:first-child{padding-left:12px;border-left:solid 1px #007aff;border-top-left-radius:36px;border-bottom-left-radius:36px;}&:last-child{padding-right:12px;border-right:solid 1px #007aff;border-top-right-radius:36px;border-bottom-right-radius:36px;}&[data-checked='true']{border-color:white;}}> ", " + ", "{margin-left:0;}"], StyledButton, StyledButton, StyledButton);
ToggleButtonsGroup.StyledButton = StyledButton;
var _default = exports["default"] = ToggleButtonsGroup;